// extracted by mini-css-extract-plugin
export default {"advertsList_wrapper":"AdvertsList_advertsList_wrapper__xfBcE","advertsList":"AdvertsList_advertsList__AuKQZ","not_found":"AdvertsList_not_found__c9BeZ"};